import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";

// ============================================
// 공유 스타일 상수
// Figma Decorate/Dimmer: Label/Normal (#171717) + opacity 28%
// Dialog/Sheet/Drawer/Sidebar Overlay 등에서 import하여 사용
// ============================================

export const DIMMER_STYLE = "bg-label-normal opacity-28";

// ============================================
// 스타일 (CVA)
// ============================================

const dimmerVariants = cva(DIMMER_STYLE, {
  variants: {
    fixed: {
      true: "fixed inset-0 z-40",
      false: "",
    },
    animated: {
      true: "transition-opacity duration-300",
      false: "",
    },
  },
  defaultVariants: {
    fixed: false,
    animated: false,
  },
});

// ============================================
// 타입 정의
// ============================================

interface DimmerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** true이면 fixed inset-0 z-40 전체화면 오버레이 */
  fixed?: boolean;
  /** true이면 opacity 트랜지션 적용 */
  animated?: boolean;
}

// ============================================
// Dimmer 컴포넌트
// Modal이나 Alert 배경을 표현합니다.
// ============================================

export const Dimmer = forwardRef<HTMLDivElement, DimmerProps>(
  ({ fixed = false, animated = false, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(dimmerVariants({ fixed, animated }), className)}
      {...rest}
    />
  ),
);

Dimmer.displayName = "Dimmer";
